import { ExperienceEntry } from 'utils/cv-form-db';

export const initialValues: ExperienceEntry = {
  companyName: '',
  position: '',
  startDate: '',
  endDate: '',
  currentlyWorking: false,
  description: ''
};
